'use client';

import { createContext, FC, ReactNode, useContext, useState } from 'react';

import { SelectAdTypeModalDynamic as SelectAdTypeModal } from '@/components/SelectAdTypeModal/SelectAdTypeModalDynamic';

interface SelectAdTypeModalContextProps {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const SelectAdTypeModalContext = createContext<
  SelectAdTypeModalContextProps | undefined
>(undefined);

export const useSelectAdTypeModal = () => {
  const context = useContext(SelectAdTypeModalContext);
  if (!context) {
    throw new Error(
      'useSelectAdTypeModal must be used within SelectAdTypeModalProvider'
    );
  }
  return context;
};

export const SelectAdTypeModalProvider: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SelectAdTypeModalContext.Provider
      value={{
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false)
      }}
    >
      <SelectAdTypeModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      {children}
    </SelectAdTypeModalContext.Provider>
  );
};
